import { apm } from "@elastic/apm-rum";
import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

interface props {
  maximizeTable?: boolean;
  visible: boolean;
  handleClose: () => void;
  children: JSX.Element | JSX.Element[];
  title: string;
}

export default function PopoverElement({
  maximizeTable,
  visible,
  handleClose,
  children,
  title,
}: props) {
  const showAxisscale = defaultStore((state) => state.showAxisscale);
  const authMode = defaultStore((state) => state.authMode);

  const darkTheme = localStorage.getItem("theme") === "dark";

  const width = "444px";
  const widthExpanded = "800px";
  const height =
    authMode === "edit" ? (showAxisscale ? "476px" : "428px") : "428px";
  const heightExpanded = "100%";

  return (
    <Box
      width={
        maximizeTable ? { xs: width, md: widthExpanded, lg: "1100px" } : width
      }
      height={visible ? (maximizeTable ? heightExpanded : height) : "0px"}
      top="-8px"
      left={visible ? "0" : "-500px"}
      sx={{
        backgroundColor: "whiteBackground.main",
        backdropFilter: "blur(10px)",
        borderRadius: "0px 10px 10px 0px",
        transition: "left 0.3s, height 0.3s, width 0.3s",
        pointerEvents: "auto",
        height: "100%",
      }}
      position="absolute"
      zIndex={1}
      padding={"8px"}
    >
      <Box
        padding={1.5}
        display={"flex"}
        flexDirection={"column"}
        gap={1}
        sx={{
          transition: "width 0.3s",
          backgroundColor: darkTheme ? "darkblue.main" : "white",
          borderRadius: "10px",
          height: "calc(100% - 24px)",
        }}
      >
        <Box
          display={"flex"}
          justifyContent="space-between"
          alignItems={"center"}
          gap={2}
          position={"sticky"}
          top="0"
        >
          <Typography
            fontSize={"18px"}
            fontWeight={700}
            sx={{ color: darkTheme ? "white" : "darkblue.main" }}
          >
            {title}
          </Typography>
          <IconButton
            onClick={() => monitor(apm, "close-popover | Toolbar", handleClose)}
            disableRipple={true}
          >
            <Close
              sx={{
                marginRight: "-8px",
                color: darkTheme ? "white" : "darkblue.main",
                "@media (hover: hover)": {
                  ":hover": { color: "secondary.main" },
                },
              }}
            />
          </IconButton>
        </Box>
        <Box width={"100%"} height="100%" overflow={"auto"}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
